export default "__VITE_ASSET__kXIdO0oJ__"